export const nameOf = (c) => (c ? c.nickname || c.alias || "Unknown" : "Unknown");

export const TIMERS = [
  { value: 0, label: "Off" },
  { value: 10, label: "10s" },
  { value: 60, label: "1m" },
  { value: 3600, label: "1h" },
  { value: 86400, label: "1d" },
];

export const timerLabel = (s) => TIMERS.find((t) => t.value === s)?.label || `${s}s`;

export function contactsMap(q) {
  return Object.fromEntries(q("SELECT * FROM contacts").map((c) => [c.code, c]));
}

export function listSessions(q, me) {
  const contacts = contactsMap(q);
  return q("SELECT * FROM sessions ORDER BY last_at DESC").map((s) => {
    const last = q("SELECT * FROM messages WHERE session_id=? ORDER BY timestamp DESC LIMIT 1", [s.session_id])[0];
    const members = JSON.parse(s.members || "[]");
    const peers = s.kind === "direct" ? [s.recipient_code] : members.filter((c) => c !== me.code);
    const statuses = peers.map((c) => contacts[c]?.lock_status || "pending");
    const lock = statuses.includes("compromised") ? "compromised" : statuses.length && statuses.every((x) => x === "connected") ? "connected" : "pending";
    const name = s.kind === "direct" ? nameOf(contacts[s.recipient_code]) : s.name;
    return { ...s, members, peers, lock, name, last: last && { ...last, content: JSON.parse(last.content || "{}") } };
  });
}

export function preview(last, meCode) {
  if (!last) return "No messages yet";
  if (last.status === "destroyed") return last.content.snap ? "Snap opened" : "Message burned";
  if (last.content.sys === "screenshot") return "Screenshot taken";
  if (last.content.react) return `${last.sender_code === meCode ? "You reacted" : "Reacted"} ${last.content.react} to a story`;
  if (last.content.snap) return last.sender_code === meCode ? "You sent a Snap" : "New Snap";
  const who = last.sender_code === meCode ? "You: " : "";
  return who + (last.content.file ? `File · ${last.content.file.name}` : last.content.text || "");
}
